
<div class="container px-lg-5">

  <div class="row d-flex flex-column align-items-center justify-content-center" style="min-height: calc(100vh - 80px)">

    <img class="img-fluid" src="assets/page_not_found.png" alt="Not found" loading="eager" style="height: 50vh; width: 50vh">
    <p class="fw-bold fs-2 text-center" style="color: #423c54">The page you are looking for was not found.</p>
    <button class="btn btn-danger w-auto" routerLink="">Home page</button>

  </div>

</div>
